import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // Demo: simulate sending reset link
      await new Promise((r) => setTimeout(r, 800));
      setSent(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="auth-card card">
        <div className="card-body text-center">
          <div className="mb-3">
            <i className="bi bi-envelope-check" style={{ fontSize: '3rem', color: 'var(--theme)' }} />
          </div>
          <h2 className="auth-title h5">Check your email</h2>
          <p className="text-muted small mb-4">
            If an account exists for <strong>{email}</strong>, we’ve sent a password reset link.
          </p>
          <Link to="/login" className="btn btn-primary">Back to sign in</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-card card">
      <div className="card-body">
        <h1 className="auth-title h4">Forgot password?</h1>
        <p className="auth-subtitle">Enter your email and we’ll send you a reset link.</p>
        {error && (
          <div className="alert alert-danger py-2 small" role="alert">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="forgot-email" className="form-label">Email</label>
            <input
              id="forgot-email"
              type="email"
              className="form-control"
              placeholder="admin@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-100" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                Sending...
              </>
            ) : (
              'Send reset link'
            )}
          </button>
        </form>
        <div className="text-center mt-3">
          <Link to="/login" className="link-secondary">
            <i className="bi bi-arrow-left me-1" />
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
